import React from 'react';
import { ListItem } from "../../../internal/List";
export var Item = function Item(_ref) {
  var handleChooseItem = _ref.handleChooseItem,
      option = _ref.option;
  var Component = option.as,
      label = option.label,
      value = option.value;

  var handleClick = function handleClick() {
    handleChooseItem(value !== null && value !== void 0 ? value : '');
  };

  return /*#__PURE__*/React.createElement(ListItem, {
    onClick: handleClick
  }, Component ? /*#__PURE__*/React.createElement(Component, option) : label);
};